import Rate6670 from './rate-66-70'
import Rate7175 from './rate-71-75'
import Rate1865 from './rate-18-65'
import Legends from './legends'
import RatesActions from './rates-actions'
import Rate7680 from './rate-76-80'
import { useProposalComputation } from '../../../../../../hooks/proposal/use-proposal-computation'

export default function ProposalComputationRates() {

    const { selectShowRates } = useProposalComputation();

    return (
        <div className='grid h-full min-h-0 grid-cols-1 gap-2'>
            <div className="min-h-0">
                <div className="flex h-full min-h-0 flex-col overflow-hidden">
                    <div className='flex-1 min-h-0 overflow-y-auto py-2 mb-1'>
                        <div className='flex flex-col space-y-2'>
                            <Legends/>
                            <div className='grid grid-cols-1 lg:grid-cols-1 gap-2'>
                                <Rate1865/>
                                {selectShowRates?.isShow6670 && <Rate6670/>}
                                {selectShowRates?.isShow7175 && <Rate7175/>}
                                {selectShowRates?.isShow7680 && <Rate7680/>}
                            </div>
                        </div>
                    </div>
                    <div className="shrink-0 border-t border-gray-200 bg-white px-2.5 py-2 sm:px-3 sm:py-2.5">
                        <RatesActions />
                    </div>
                </div>
            </div>
        </div>
    )
}